{
  "login": {
    "genericError": "Ocorreu um erro durante o login. Por favor, tente novamente."
  },
  "acceptTerms": {
    "pleaseAccept": "Aceite os Termos e condições para continuar",
    "accepted": "Termos e condições aceitos",
    "failedGeneric": "Falha ao aceitar os termos. Por favor, tente novamente."
  },
  "discord": {
    "linkSuccess": "Conta Discord vinculada! Por favor, verifique seus DMs abaixo.",
    "linkFailed": "Falha ao vincular conta Discord: {{message}}",
    "verificationSent": "Código de verificação enviado para seus DMs do Discord!",
    "dmVerified": "DMs do Discord verificados com sucesso! As notificações já estão disponíveis.",
    "settingToggled": "{{label}} {{state}}",
    "unlinked": "Conta Discord desvinculada com sucesso!",
    "userIdNotFound": "ID do usuário não encontrado. Por favor, faça login novamente.",
    "clientIdNotConfigured": "ID do cliente Discord não configurado. Verifique suas variáveis de ambiente.",
    "redirectUriNotConfigured": "URL de redirecionamento não configurado corretamente. Verifique suas variáveis de ambiente.",
    "allowPopups": "Por favor, permita pop-ups neste site para vincular sua conta do Discord",
    "linkFirst": "Por favor, vincule primeiro sua conta do Discord",
    "sendCodeFailed": "Falha ao enviar o código de verificação. Certifique-se de que o bot pode te enviar DMs.",
    "sendCodeFailedGeneric": "Falha ao enviar o código de verificação",
    "enterCode": "Por favor, insira o código de verificação",
    "verifyCodeFailed": "Falha ao verificar o código. Por favor, tente novamente.",
    "verifyFirst": "Por favor, verifique primeiro seus DMs do Discord",
    "updateSettingFailed": "Falha ao atualizar a configuração de notificação",
    "unlinkFailed": "Falha ao desvincular a conta do Discord",
    "categoryUpdated": "Categoria atualizada",
    "categoryUpdateFailed": "Não foi possível atualizar a categoria",
    "categoryDeleted": "Categoria excluída",
    "categoryDeleteFailed": "Não foi possível excluir a categoria",
    "defaultCategoryUpdated": "Categoria padrão atualizada",
    "setDefaultFailed": "Não foi possível definir a categoria padrão",
    "categoryCreated": "Categoria criada",
    "categoryCreateFailed": "Não foi possível criar a categoria"
  },
  "subscription": {
    "failedLoadPricing": "Falha ao carregar informações de preços",
    "failedCheckout": "Falha ao iniciar o checkout",
    "failedChangeSubscription": "Falha ao alterar a assinatura",
    "failedOpenBillingPortal": "Falha ao abrir o portal de faturamento",
    "cancelSuccess": "Sua assinatura foi cancelada com sucesso",
    "cancelFailed": "Falha ao cancelar a assinatura",
    "resumeSuccess": "Sua assinatura foi retomada com sucesso",
    "resumeFailed": "Falha ao retomar a assinatura",
    "updateSuccess": "Sua assinatura foi atualizada!",
    "newSubscriptionSuccess": "Bem-vindo! Sua assinatura está ativa."
  },
  "trial": {
    "activated": "Teste ativado! Aproveite 7 dias de FlippingPal.",
    "activationFailed": "Falha ao ativar o teste"
  },
  "account": {
    "emailBothFieldsRequired": "Por favor preencha os dois campos",
    "emailInvalid": "Por favor insira um endereço de e-mail válido",
    "emailUpdated": "E-mail atualizado! Verifique seu novo e-mail para confirmar. Saindo...",
    "emailFailed": "Falha ao alterar o e-mail",
    "passwordAllFieldsRequired": "Por favor preencha todos os campos de senha",
    "passwordTooShort": "A nova senha deve ter pelo menos 4 caracteres",
    "passwordsDoNotMatch": "As novas senhas não coincidem",
    "passwordChanged": "Senha alterada com sucesso!",
    "passwordFailed": "Falha ao alterar a senha",
    "closeAccountPasswordRequired": "Por favor insira sua senha",
    "closeAccountConfirmRequired": "Por favor digite \"FECHAR MINHA CONTA\" para confirmar",
    "accountClosed": "Conta fechada. Saindo...",
    "closeAccountFailed": "Falha ao fechar a conta"
  },
  "snipe": {
    "ilvlEnterAtLeastOne": "Por favor insira pelo menos um ilvl mínimo ou máximo",
    "ilvlValidMin": "Por favor insira um ilvl mínimo válido",
    "ilvlValidMax": "Por favor insira um ilvl máximo válido",
    "ilvlMinExceedsMax": "O ilvl mínimo não pode exceder {{max}}",
    "ilvlMaxExceedsMax": "O ilvl máximo não pode exceder {{max}}",
    "ilvlMinGreaterThanMax": "O ilvl mínimo não pode ser maior que o ilvl máximo",
    "ilvlValidPrice": "Por favor insira um preço válido (ex. 100g, 50g 30s, ou 100)",
    "reqLvlMinRange": "O nível mínimo requerido deve estar entre {{min}} e {{max}}",
    "reqLvlMaxRange": "O nível máximo requerido deve estar entre {{min}} e {{max}}",
    "reqLvlMinGreaterThanMax": "O nível mínimo requerido não pode ser maior que o nível máximo requerido",
    "ilvlAdded": "Snipe ilvl adicionado",
    "ilvlUpdated": "Snipe ilvl atualizado",
    "ilvlSaveFailed": "Falha ao salvar o snipe ilvl",
    "ilvlRemoved": "Snipe ilvl removido",
    "ilvlRemoveFailed": "Falha ao remover o snipe ilvl",
    "selectItem": "Por favor selecione um item",
    "validPetId": "Por favor insira um ID de mascote válido ou pesquise um mascote",
    "invalidPrice": "Por favor insira um preço válido (ex. 100g, 50g 30s, ou 100)",
    "itemAdded": "Snipe {{label}} adicionado",
    "itemUpdated": "Snipe {{label}} atualizado",
    "itemAddFailed": "Falha ao adicionar snipe {{type}}",
    "itemRemoved": "Snipe {{type}} removido",
    "itemRemoveFailed": "Falha ao remover snipe {{type}}",
    "editingWoWToken": "Editando alerta de snipe WoW Token",
    "editingSnipeAlert": "Editando alerta de snipe para {{name}}",
    "itemNotFound": "{{label}} não encontrado.",
    "importInvalidArrayFormat": "Formato inválido. Era esperado um array de regras snipe ilvl.",
    "importNoValidEntries": "Nenhuma entrada válida encontrada. Os itens do array precisam dos campos \"{{idKey}}\" e \"price\".",
    "importInvalidJsonFormat": "Formato JSON inválido. Era esperado { {{idKey}}: goldPrice, ... } ou um array de objetos.",
    "importSuccess": "Importação: {{added}} adicionado(s), {{updated}} atualizado(s), {{skipped}} ignorado(s)",
    "importIlvlSuccess": "{{count}} regra(s) snipe ilvl importada(s)",
    "importParseFailed": "Falha ao analisar ou importar o JSON",
    "noItemsToExport": "Nenhum {{type}} para exportar",
    "noIlvlItemsToExport": "Nenhum item ilvl para exportar",
    "exportSuccess": "{{count}} {{type}} exportado(s)",
    "exportIlvlSuccess": "{{count}} item(ns) ilvl exportado(s)",
    "enabledToggle": "Alertas de snipe {{state}}",
    "enabledToggleFailed": "Falha ao atualizar configuração de snipe",
    "alertStyleUpdated": "Estilo de alerta definido como {{style}}",
    "alertStyleFailed": "Falha ao atualizar o estilo de alerta",
    "realmsSaved": "Reinos de snipe salvos",
    "realmsSaveFailed": "Falha ao salvar os reinos de snipe",
    "clearAllConfirm": "Tem certeza de que deseja remover todos os snipes {{label}}?",
    "clearAllSuccess": "Todos os snipes {{label}} removidos",
    "clearAllFailed": "Falha ao remover os snipes {{label}}",
    "cooldownCyclesUpdated": "Cooldown de alertas definido para {{cycles}} ciclo(s) pulado(s)",
    "cooldownCyclesFailed": "Falha ao atualizar o cooldown de alertas",
    "cooldownCyclesInvalid": "O cooldown deve estar entre 0 e 24 ciclos",
    "undo": "Desfazer",
    "undoRestored": "Alerta de snipe restaurado",
    "undoFailed": "Falha ao restaurar o alerta de snipe",
    "priceUpdated": "Preço atualizado",
    "priceUpdateFailed": "Falha ao atualizar o preço"
  },
  "personalConfig": {
    "saveSuccess": "Filtros padrão salvos com sucesso!",
    "saveFailed": "Falha ao salvar os filtros padrão"
  },
  "auth": {
    "registrationSuccessEmail": "Registro realizado com sucesso! Por favor, verifique seu e-mail.",
    "registrationSuccessLogin": "Registro realizado com sucesso! Por favor, faça login com sua nova conta.",
    "passwordResetSuccess": "Senha redefinida com sucesso"
  },
  "common": {
    "networkError": "Erro de rede. Por favor, tente novamente."
  },
  "validation": {
    "passwordRequired": "A senha é obrigatória",
    "passwordMinLength": "A senha deve ter pelo menos {{count}} caracteres",
    "passwordUppercase": "A senha deve conter pelo menos uma letra maiúscula",
    "passwordLowercase": "A senha deve conter pelo menos uma letra minúscula",
    "passwordNumber": "A senha deve conter pelo menos um número",
    "passwordSpecialChar": "A senha deve conter pelo menos um caractere especial",
    "confirmPasswordRequired": "Por favor, confirme sua senha",
    "passwordsDoNotMatch": "As senhas não coincidem",
    "emailRequired": "O e-mail é obrigatório",
    "emailInvalid": "Por favor, insira um endereço de e-mail válido"
  },
  "filterPreset": {
    "fetchFailed": "Falha ao carregar os presets de filtro",
    "createFailed": "Falha ao criar o preset de filtro",
    "updateFailed": "Falha ao atualizar o preset de filtro",
    "deleteFailed": "Falha ao excluir o preset de filtro",
    "invalidImportNotObject": "String de importação inválida: não é um objeto de preset válido",
    "invalidImportMissingVersion": "String de importação inválida: informações de versão ausentes",
    "invalidImportMissingPreset": "String de importação inválida: dados do preset ausentes",
    "invalidPresetMissingName": "Preset inválido: nome ausente ou inválido",
    "invalidPresetMissingFilters": "Preset inválido \"{{name}}\": filtros ausentes ou inválidos"
  }
}
